<script lang="ts">
    import type { RequestBuilder } from "@lernetz/request";
    import { get } from './defaultRequest';

    export let name: string;
    export let request: RequestBuilder = get();
</script>

<svg {...$$restProps} >
    <use xlink:href={ request.hash(name).url }/>
</svg>
